"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const round_1 = require("./round");
const formatWithPattern_1 = require("./formatWithPattern");
const index_1 = require("../index");
const getBasicFormat = (amount, precision, { decimalSeparator, symbol, groupSize, groupSeparator, pattern }) => {
    let [integer, fraction] = round_1.default(amount, precision).split(index_1.SEPARATORS.DOT);
    // exclude "-" if amount is negative.
    if (integer < 0) {
        integer = integer.substring(1);
    }
    let value = integer;
    let l = integer.length;
    if (l >= groupSize) {
        value = "";
        for (let i = 0; i < l; i++) {
            if (i > 0 && (l - i) % groupSize === 0) {
                value += groupSeparator;
            }
            value += integer.charAt(i);
        }
    }
    if (fraction) {
        value += decimalSeparator + fraction;
    }
    return formatWithPattern_1.default(pattern, value, symbol);
};
exports.default = getBasicFormat;
